import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import { FiFilter, FiEdit, FiEdit2 } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { BsDownload, BsArrowLeft } from "react-icons/bs";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import * as Icon from "react-icons/fi";
import Checkbox from "react-custom-checkbox";
import { beneficiaryStatus } from "../../utils/DataSource";
import {
  addnewProperty,
  deleteProperty,
  getProperties,
  updateProperty,
} from "../../store/actions/PropertiesActions";
import {
  addBenProperty,
  deleteBenProperty,
  getBenProperties,
  updateBenProperty,
} from "../../store/actions/BenProperties";

import { getBeneficiries } from "../../store/actions/BenActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import ContentLoader from "react-content-loader";

function ViewEconomy() {
  const dispatch = useDispatch();

  const properties = useSelector((state) => state.propetiesState.properties);
  const benProperties = useSelector((state) => state.benPropetiesState);
  const loaders = useSelector((state) => state.loadersState);

  const beneficiaries = useSelector((state) => state.beneficiries);

  const [openTab, setOpenTab] = useState(1);
  const [propertyDropdown, setpropertyDropDown] = useState(0);

  const [openUpperTab, setOpenUpperTab] = useState(1);
  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    setBenProperty({
      id: "",
      beneficiaryId: "",
      createdAt: "",
      propertiesIds: [],
    });
    setChosenProperties([]);
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedPropInfo) {
    setBenProperty({
      id: passedPropInfo.id,
      beneficiaryId: passedPropInfo.beneficiary.id,
      createdAt: passedPropInfo.createdAt,
      propertiesIds: passedPropInfo.properties,
    });
    setChosenProperties([]);

    for (let index = 0; index < passedPropInfo.properties.length; index++) {
      const propInfo = {
        numberOfPropertiesOwned:
          passedPropInfo.properties[index].numberOfPropertiesOwned,
        property: {
          idValue: passedPropInfo.properties[index].property.id,
        },
      };
      setChosenProperties((chosenProperties) => [
        ...chosenProperties,
        propInfo,
      ]);
    }
    setEditBeneOverlay(!editBenOverlay);
  }

  const [addproperty, setAddproperty] = useState(0);
  function addpropertyController() {
    setAddproperty(!addproperty);
  }
  const [editproperty, setEditproperty] = useState(0);
  function editpropertyController(passedProperty) {
    setEditproperty(!editproperty);
    setProperty({
      id: passedProperty.id,
      name: passedProperty.name,
      createdAt: passedProperty.createdAt,
    });
  }

  const [property, setProperty] = useState({
    id: "",
    createdAt: "",
    name: "",
  });

  const [benProperty, setBenProperty] = useState({
    id: "",
    beneficiaryId: "",
    createdAt: "",
    propertiesIds: [],
  });

  // for property table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "Properties",
        accessor: "property",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform beneficiary economy data
  let [loadedProperties, setLoadedProperties] = useState([]);

  useEffect(() => {
    setLoadedProperties([]);
    for (let i = 0; i < benProperties.length; i++) {
      const propertyOwner = {
        count: i + 1,
        id: benProperties[i].id,
        beneficiary: `${benProperties[i].beneficiary.firstName}  
        ${benProperties[i].beneficiary.lastName}`,
        property: (
          <div className="flex flex-wrap">
            {benProperties[i].properties.map((ourProperty, i) => {
              return (
                <div
                  className="mr-2 my-1 text-indigo-500 bg-indigo-100  border border-indigo-100 px-2 rounded fit-content"
                  key={i}
                >
                  {ourProperty.numberOfPropertiesOwned +
                    " " +
                    ourProperty.property.name}
                </div>
              );
            })}
          </div>
        ),
        action: (
          <Action
            deleteAction={() => {
              handleDeleteBenProperty(benProperties[i].id);
            }}
            editAction={() => editOverlayController(benProperties[i])}
            benId={benProperties[i].id}
          />
        ),
      };
      setLoadedProperties((loadedProperties) => [
        ...loadedProperties,
        propertyOwner,
      ]);

      if (
        loaders.benProperty.deletingAction &&
        loaders.benProperty.deletingAction.deleting
      ) {
        const currentBenProperties = loadedProperties;
        const newData = currentBenProperties.map((benProperty) =>
          benProperty.id === loaders.benProperty.deletingAction.id
            ? {
                ...benProperty,
                action: (
                  <div className="spinner red-spinner m-auto">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
                ),
              }
            : benProperty
        );
        setLoadedProperties(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benProperties, loaders.benProperty.deletingAction]);

  let [loadingBenProperties, setLoadingBenProperties] = useState([]);

  useEffect(() => {
    setLoadingBenProperties([]);
    for (let i = 0; i < 5; i++) {
      const propertyOwner = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        property: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };

      setLoadingBenProperties((loadingBenProperties) => [
        ...loadingBenProperties,
        propertyOwner,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benProperty.fetchingLoaders]);
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    dispatch(getProperties());
    dispatch(getBenProperties());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle property submit
  const handlePropertySubmit = (e) => {
    e.preventDefault();
    if (property.id) {
      const id = property.id;
      const updatedProperty = {
        name: property.name,
        createdAt: property.description,
      };
      dispatch(updateProperty(updatedProperty, id, closePropertyAfterUpdating));
    } else {
      dispatch(addnewProperty(property, closePropertyFormAfterAdding));
    }
  };

  // closing property after cu
  function closePropertyFormAfterAdding() {
    addpropertyController();
    setProperty({
      id: "",
      createdAt: new Date(),
      name: "",
    });
  }

  function closePropertyAfterUpdating() {
    editpropertyController({
      id: "",
      createdAt: "",
      name: "",
    });
  }

  // handle property deletion
  const handlePropertyDelete = (id) => {
    dispatch(deleteProperty(id));
  };

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }
  // selected beneficiary
  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === benProperty.beneficiaryId
  );

  const [chosenProperties, setChosenProperties] = useState([]);

  function addPropertyToBenProp(propInfo) {
    const foundProperty = chosenProperties.find(
      (prop) => prop.property.idValue === propInfo.property.idValue
    );

    if (!foundProperty) {
      setChosenProperties((chosenProperties) => [
        ...chosenProperties,
        propInfo,
      ]);
    } else {
      setChosenProperties(
        chosenProperties.filter(
          (prop) => prop.property.idValue !== propInfo.property.idValue
        )
      );
    }
  }

  // handleBenPropertySubmit
  const handleBenPropertySubmit = (e) => {
    e.preventDefault();
    if (benProperty.id) {
      const id = benProperty.id;
      const updatedBenProperty = {
        beneficiaryId: {
          idValue: benProperty.beneficiaryId,
        },
        createdAt: new Date(),
        propertiesIds: chosenProperties,
      };
      dispatch(
        updateBenProperty(updatedBenProperty, id, closeBenPropertyAfterUpdating)
      );
    } else {
      const newBenProperty = {
        id: benProperty.id,
        beneficiaryId: {
          idValue: benProperty.beneficiaryId,
        },
        createdAt: new Date(),
        propertiesIds: chosenProperties,
      };
      dispatch(addBenProperty(newBenProperty, closeBenPropertyFormAfterAdding));
    }
  };

  // closing ben property after cu
  function closeBenPropertyFormAfterAdding() {
    benOverlayController();
    setBenProperty({
      id: "",
      beneficiary: { id: "" },
      createdAt: "",
      propertiesIds: [],
    });
    setChosenProperties([]);
  }

  function closeBenPropertyAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiary: { id: "" },
      createdAt: "",
      properties: [],
    });
    setChosenProperties([]);
  }

  // handle beneficiary property delete
  const handleDeleteBenProperty = (id) => {
    dispatch(deleteBenProperty(id));
  };

  function clearErrors() {
    dispatch({
      type: "SET_BEN_PROPERTY_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_PROPERTY_MESSAGE",
      message: "",
    });
  }

  function handlePropAmountChange(newValue, idValue) {
    const newProp = {
      numberOfPropertiesOwned: newValue,
      property: {
        idValue: idValue,
      },
    };
    const currentProps = chosenProperties;
    setChosenProperties([]);
    setChosenProperties(
      currentProps.map((property) =>
        property.property.idValue === idValue ? newProp : property
      )
    );
    console.log(chosenProperties);
  }

  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="mx-10 bg-white">
        <div className="flex flex-col md:flex-row p-10 pt-5 pl-10 pb-0">
          <h2 className="font-semibold">Beneficiries economy</h2>
          <div className="mt-2 md:m-auto md:mr-0">
            <button
              className={
                openUpperTab === 1
                  ? "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                  : "hidden"
              }
              onClick={() => {
                benOverlayController();
              }}
            >
              <FiEdit />
            </button>

            <button
              className={
                openUpperTab === 1
                  ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                  : "hidden"
              }
              onClick={() => {
                filterOverlayController();
              }}
            >
              <FiFilter />
            </button>
            <button
              className={
                openUpperTab === 1
                  ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                  : "hidden"
              }
              onClick={() => {
                dispatch(getBenProperties());
              }}
            >
              <FcRefresh
                className={
                  loaders.benProperty.fetchingLoaders ? " refresh-loader" : " "
                }
              />
            </button>
            <button
              className={
                openUpperTab === 1
                  ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                  : "hidden"
              }
            >
              <BsDownload />
            </button>
          </div>
        </div>
        {/* property tabs */}
        <div className="flex mt-2 flex-wrap">
          <div className="w-full">
            <ul
              className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full"
              role="tablist"
            >
              <li className="-mb-px  last:mr-0 ml-10">
                <a
                  className={
                    "text-xs   px-5 py-1 pl-0   block leading-normal" +
                    (openUpperTab === 1
                      ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                        color +
                        "-500"
                      : " text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-r-none border-indigo-300")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenUpperTab(1);
                  }}
                  data-toggle="tab"
                  href="#link1"
                  role="tablist"
                >
                  <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                  Beneficiries
                </a>
              </li>
              <li className="-mb-px  last:mr-0">
                <a
                  className={
                    "text-xs   px-5 py-1 pl-0  block leading-normal " +
                    (openUpperTab === 2
                      ? " text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                        color +
                        "-500"
                      : "text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-l-none border-indigo-300")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenUpperTab(2);
                  }}
                  data-toggle="tab"
                  href="#link2"
                  role="tablist"
                >
                  <i className="fas fa-cog text-base mr-1"></i> Information
                </a>
              </li>
            </ul>
            <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
              <div>
                <div className="tab-content tab-space">
                  <div
                    className={openUpperTab === 1 ? "flex flex-col" : "hidden"}
                    id="link1"
                  >
                    <div className="pb-5 px-0  pr-10  flex flex-wrap  w-full">
                      {/* property table */}
                      <div className="w-full ">
                        {(!loaders.benProperty.fetchingLoaders &&
                          benProperties.length < 1) |
                        loaders.benProperty.fetchFailedMessage ? (
                          <div
                            className={
                              !loaders.benProperty.fetchFailedMessage
                                ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                            }
                          >
                            <p>
                              {!loaders.benProperty.fetchFailedMessage
                                ? "No economy record found"
                                : loaders.benProperty.fetchFailedMessage}
                            </p>
                          </div>
                        ) : (
                          <Table
                            data={
                              loaders.benProperty.fetchingLoaders
                                ? loadingBenProperties
                                : loadedProperties
                            }
                            columns={columns}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Economys table */}
                  <div
                    className={openUpperTab === 2 ? "flex flex-col" : "hidden"}
                    id="link1"
                  >
                    <div className="pb-5 px-0 flex flex-wrap  w-full">
                      {/* Academics table */}
                      <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                        <div className="flex flex-col md:flex-row  p-5">
                          <div className="font-semibold md:w-2/12">
                            Description
                          </div>
                          <div className="text-justify md:w-8/12">
                            {
                              "This services provides information about properties beneficiary family have eg.houses,domestic animals,..."
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end.... */}
        {/*add property overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.benProperty.message && openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benProperty.message}</p>
              </div>

              <div
                className={
                  loaders.property.message && openTab === 2
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.property.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Register beneficiary property"
                      : "Change beneficiary property info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                              id: "",
                              beneficiary: { id: "" },
                              createdAt: "",
                              properties: [],
                            });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex mb-0 list-none flex-wrap  font-medium  flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? "text-indigo-500 border-b-2 border-" +
                                color +
                                "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Porperty info
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                                color +
                                "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i>{" "}
                          Properties
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleBenPropertySubmit}
                            >
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Beneficiary Id</label>
                                <Select
                                  options={beneficiriesOption}
                                  value={beneficiriesOption.find(
                                    (obj) =>
                                      obj.value === benProperty.beneficiaryId
                                  )}
                                  onChange={(e) =>
                                    setBenProperty({
                                      ...benProperty,
                                      beneficiaryId: e.value,
                                    })
                                  }
                                />
                              </div>

                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Name </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input + "uppercase"}
                                    value={
                                      benProperty.beneficiaryId
                                        ? selectedBeneficiary[0].name
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="flex flex-col">
                                {properties.map((property, i) => {
                                  const newProperty = {
                                    property: {
                                      idValue: property.id,
                                    },
                                  };

                                  return (
                                    <div
                                      className="py-2 w-auto mr-2 flex"
                                      key={i}
                                    >
                                      <div className="flex">
                                        <Checkbox
                                          icon={
                                            <Icon.FiCheck
                                              color="#174A41"
                                              size={14}
                                            />
                                          }
                                          name={property.name}
                                          checked={
                                            chosenProperties.find(
                                              (prop) =>
                                                prop.property.idValue ===
                                                property.id
                                            )
                                              ? true
                                              : false
                                          }
                                          onChange={() => {
                                            addPropertyToBenProp(newProperty);
                                          }}
                                          borderColor="#73859d"
                                          style={{ cursor: "pointer" }}
                                          labelStyle={{
                                            userSelect: "none",
                                            marginLeft: 5,
                                          }}
                                          label={"Have " + property.name}
                                        />{" "}
                                        <div
                                          className={
                                            chosenProperties.find(
                                              (prop) =>
                                                prop.property.idValue ===
                                                property.id
                                            )
                                              ? "ml-3 w-14"
                                              : "hidden"
                                          }
                                        >
                                          <div
                                            className={
                                              "border border-indigo-200 py-2 px-3 w-full rounded flex flex-row focus-within:bg-gray-100 focus-within:border-indigo-500"
                                            }
                                          >
                                            <input
                                              type="number"
                                              className={style.field.input}
                                              value={
                                                chosenProperties.find(
                                                  (prop) =>
                                                    prop.property.idValue ===
                                                    property.id
                                                )
                                                  ? chosenProperties.find(
                                                      (prop) =>
                                                        prop.property
                                                          .idValue ===
                                                        property.id
                                                    ).numberOfPropertiesOwned
                                                  : null
                                              }
                                              onChange={(e) =>
                                                handlePropAmountChange(
                                                  e.target.value,
                                                  property.id
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              {/* save btn */}
                              <button
                                type="submit"
                                className={style.loginBtn}
                                disabled={loaders.benProperty.sendingLoader}
                              >
                                <p className="m-auto">
                                  {!loaders.benProperty.sendingLoader ? (
                                    <p className="m-auto">
                                      {addBenOverlay ? "Save" : "Update"}
                                    </p>
                                  ) : (
                                    <div className="spinner m-auto">
                                      <div className="bounce1"></div>
                                      <div className="bounce2"></div>
                                      <div className="bounce3"></div>
                                    </div>
                                  )}{" "}
                                </p>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addproperty & !editproperty
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addpropertyController();
                                }}
                              >
                                {"Add property"}
                              </button>
                              <div
                                className={
                                  !addproperty & !editproperty
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.property.fetchingLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  properties.map((property, i) => {
                                    return loaders.property.deletingAction &&
                                      loaders.property.deletingAction.id ===
                                        property.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "border border-gray-300 p-3 mb-3 rounded bg-gray-100 flex"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setpropertyDropDown(i);
                                        }}
                                      >
                                        <div className="flex mb-2 m-auto mx-0 text-start cursor-pointer">
                                          <h2 className="font-semibold m-auto">
                                            {property.name}
                                          </h2>
                                        </div>
                                        <div
                                          className={
                                            propertyDropdown === i
                                              ? "flex flex-col ml-auto"
                                              : "hidden"
                                          }
                                        >
                                          <div className="flex m-auto fit-content">
                                            <button
                                              className="flex p-1 rounded border border-gray-300 hover:border-gray-300 bg-gray-300 text-gray-500 mr-2"
                                              onClick={() => {
                                                editpropertyController(
                                                  property
                                                );
                                              }}
                                            >
                                              <FiEdit2 />
                                            </button>
                                            <button
                                              className="flex p-1 rounded border border-red-300 hover:border-red-300 bg-red-300 text-red-500 mr-2"
                                              onClick={() => {
                                                handlePropertyDelete(
                                                  property.id
                                                );
                                              }}
                                            >
                                              <AiOutlineDelete />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add property */}
                              <form
                                onSubmit={handlePropertySubmit}
                                className={
                                  addproperty || editproperty
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                              >
                                <h2 className="font-semibold">
                                  {addproperty
                                    ? "Register property"
                                    : "Change property info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={property.name}
                                      onChange={(e) =>
                                        setProperty({
                                          ...property,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <button
                                    type="submit"
                                    className={style.loginBtn}
                                    disabled={loaders.property.sendingLoader}
                                  >
                                    {!loaders.property.sendingLoader ? (
                                      <p className="m-auto">
                                        {addproperty ? "Save" : "Update"}
                                      </p>
                                    ) : (
                                      <div className="spinner m-auto">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    )}
                                  </button>
                                </div>
                                <p
                                  className={
                                    addproperty | editproperty
                                      ? "p-3 pl-0 flex rounded text-indigo-500 font-normal mb-3 m-auto cursor-pointer"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addproperty
                                      ? addpropertyController()
                                      : editpropertyController();
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>

        {/* filter property  overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold w-80">{"Kuyungurura imitungo"}</h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col pt-3">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Nomero</label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>{" "}
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Umutungo bafite </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Umutungo badafite </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">{"Kuyungurura"}</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>
    </DashLayout>
  );
}

export default ViewEconomy;
